import React, { useEffect, useState } from "react"

import { Form, FormGroup, Input, Label, Row, Col } from "reactstrap"

import mail from "../../assets/images/icons/mail.svg"
import phone from "../../assets/images/icons/phone-icon.svg"
import {
  useInvestorUpdatePasswordMutation,
  useInvestorUpdateWpAccessMutation,
} from "store/api/investorapi/auth.api"
import toast from "react-hot-toast"
import { useFormik } from "formik"
import * as Yup from "yup"
import { useWealthPartnerUpdatePasswordMutation } from "store/api/wealthpartnerapi/auth/auth.api"
import UpdatePhone from "./updatePhone"
import UpdateEmail from "./updateEmail"
import { setLoginUserData } from "store/slices/userSlice"
import { useDispatch } from "react-redux"
import Spinners from "components/Common/Spinner"

const initialValues = {
  currentPassword: "",
  password: "",
  confirmNewPassword: "",
}

const UpdateProfile = ({ userDetails, userType }) => {
  const [investorMutate, { isLoading }] = useInvestorUpdatePasswordMutation()
  const [wealthMutate, { isLoading: isWealthLoading }] =
    useWealthPartnerUpdatePasswordMutation()
  const [updatewpAccess, { isLoading: isUpdating }] =
    useInvestorUpdateWpAccessMutation()
  const [phoneOpen, setPhoneOpen] = useState(false)
  const [emailOpen, setEmailOpen] = useState(false)
  const [accessEnabled, setAccessEnabled] = useState(false)
  const dispatch = useDispatch()

  const canAccess = () => {
    if (userType === "INVESTOR" && userDetails.user_type === "SUB_INVESTOR") {
      return false
    }

    return true
  }
  const onFormSubmit = async (values) => {
    try {
      if (userType === "INVESTOR") {
        const { success, message } = await investorMutate(values).unwrap()
        if (success) {
          toast.success(message, { id: "passwordUpdateSuccess" })
        }
      } else if (userType === "WEALTH_PARTNER") {
        const { success, message } = await wealthMutate(values).unwrap()
        if (success) {
          toast.success(message, { id: "passwordUpdateSuccess" })
        }
      }
    } catch (error) {
      const data = error?.data
      if (data?.errors) {
        const { errors } = data
        validation.setErrors(errors)
      }
      toast.error(error?.data?.message, { id: "toastMessage" })
    }
  }

  const validation = useFormik({
    initialValues,
    validationSchema: Yup.object({}),

    onSubmit: (values) => {
      onFormSubmit(values)
    },
  })

  useEffect(() => {
    if (userType === "INVESTOR" && userDetails) {
      setAccessEnabled(userDetails.allow_wealth_partner)
    }
  }, [userType, userDetails])

  const updateAccessEnabled = async () => {
    try {
      const { message } = await updatewpAccess().unwrap()
      dispatch(
        setLoginUserData({
          user: {
            ...userDetails,
            allow_wealth_partner: !accessEnabled,
          },
        })
      )
      // setAccessEnabled(!accessEnabled)
      toast.success(message, { id: "toasterMessage" })
    } catch (error) {
      toast.error(error?.data?.message, { id: "toasterMessage" })
    }
  }

  return (
    <>
      <Row className="">
        <Col xl={12}>
          <div className="platform-heading-section mb-4">
            <h4>Personal info</h4>
            <p>Update your personal details here.</p>
          </div>
        </Col>

        <Form
          onSubmit={(e) => {
            e.preventDefault()
            validation.handleSubmit()
            return false
          }}
        >
          <FormGroup row className="mb-4">
            <Label className="form-label" md={3}>
              Name
            </Label>
            <Col md={6}>
              <Input
                id=""
                value={
                  userDetails.user_type === "SUB_INVESTOR"
                    ? userDetails?.uname
                    : userDetails?.name
                }
                disabled
                name="text"
                placeholder="Name"
                type="text"
                className="form-control"
              />
            </Col>
          </FormGroup>
          <FormGroup row className="mb-4">
            <Label className="form-label" md={3}>
              Email Address
            </Label>
            <Col md={4}>
              <div className="mail-input-wrapper">
                <Input
                  id=""
                  value={userDetails?.email || ""}
                  disabled
                  placeholder="Email Address"
                  type="email"
                  className="form-control"
                />
                <img src={mail} alt="" />
              </div>
            </Col>
            <Col md={5}>
              <button
                type="button"
                onClick={() => setEmailOpen(true)}
                className="btn btn-cancel w-md"
              >
                Change Email Address
              </button>
            </Col>
          </FormGroup>
          {canAccess() && (
            <FormGroup row className="mb-3">
              <Label className="form-label" md={3}>
                Phone No.
              </Label>
              <Col md={4}>
                <div className="mail-input-wrapper">
                  <Input
                    id=""
                    value={userDetails?.phone || ""}
                    disabled
                    placeholder="Phone No."
                    type="text"
                    className="form-control"
                  />
                  <img src={phone} alt="" />
                </div>
              </Col>
              <Col md={5}>
                <button
                  type="button"
                  onClick={() => setPhoneOpen(true)}
                  className="btn btn-cancel w-md"
                >
                  Change Phone No.
                </button>
              </Col>
            </FormGroup>
          )}

          {/* <Row>
            <Col xl={12}>
              <div className="platform-heading-section my-4">
                <h4>Change Password</h4>
                <p>
                  Please enter your current password to change your password.
                </p>
                <hr />
              </div>
            </Col>
          </Row> */}
          {/* <FormGroup row>
            <Label className="form-label" md={4}>
              Current password <span className="error">*</span>
            </Label>
            <Col md={6}>
              <Input
                id=""
                name="currentPassword"
                placeholder="Current password"
                type="password"
                className="form-control"
                value={validation.values.currentPassword}
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                invalid={
                  validation.touched.currentPassword &&
                  !!validation.errors.currentPassword
                }
              />
              {validation.touched.currentPassword &&
              validation.errors.currentPassword ? (
                <FormFeedback type="invalid">
                  {validation.errors.currentPassword}
                </FormFeedback>
              ) : null}
            </Col>
            <hr className="mt-3" />
          </FormGroup>
          <FormGroup row>
            <Label className="form-label" md={4}>
              New password <span className="error">*</span>
            </Label>
            <Col md={6}>
              <Input
                id=""
                name="password"
                placeholder="New password"
                type="password"
                className="form-control"
                value={validation.values.password}
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                invalid={
                  validation.touched.password && !!validation.errors.password
                }
              />
              {validation.touched.password && validation.errors.password ? (
                <FormFeedback type="invalid">
                  {validation.errors.password}
                </FormFeedback>
              ) : null}
            </Col>
            <hr className="mt-3" />
          </FormGroup>
          <FormGroup row className="mb-2">
            <Label className="form-label" md={4}>
              Confirm new password <span className="error">*</span>
            </Label>
            <Col md={6}>
              <div className="input-wrapper">
                <Input
                  id=""
                  name="confirmNewPassword"
                  placeholder="Confirm new password"
                  type={show ? "text" : "password"}
                  className="form-control"
                  value={validation.values.confirmNewPassword}
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  invalid={
                    validation.touched.confirmNewPassword &&
                    !!validation.errors.confirmNewPassword
                  }
                />

                <div onClick={() => setShow((prev) => !prev)}>
                  {show ? <img src={hide} alt="" /> : <img src={eye} alt="" />}
                </div>
              </div>
              {validation.touched.confirmNewPassword &&
              validation.errors.confirmNewPassword ? (
                <FormFeedback type="invalid">
                  {validation.errors.confirmNewPassword}
                </FormFeedback>
              ) : null}
            </Col>
          </FormGroup> */}
          {/* <Row className="justify-content-end my-4">
            <Col sm={12}>
              <div className="d-flex justify-content-end align-items-center gap-3">
                <button type="submit" className="btn btn-cancel w-md">
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-primary w-md"
                  disabled={isLoading || isWealthLoading}
                >
                  {isLoading || isWealthLoading ? (
                    <Spinners />
                  ) : (
                    "Update password"
                  )}
                </button>
              </div>
            </Col>
          </Row> */}
        </Form>
        {userType === "INVESTOR" && userDetails?.wealth_partner_id && (
          <>
            <hr className="mt-4" />
            <Col xl={8}>
              <div className="d-flex justify-content-between gap-3 align-items-center">
                <div className="platform-heading-section mt-4 mb-4">
                  <h4>Wealth Partner Access</h4>
                  <p>
                    Choose whether to grant your wealth partner access to <br />
                    perform ICD actions on your behalf.
                  </p>
                </div>
                <Form>
                  {isUpdating ? (
                    <Spinners color="dark" />
                  ) : (
                    <FormGroup switch>
                      <Input
                        type="switch"
                        role="switch"
                        id="enableAccess"
                        checked={accessEnabled}
                        onClick={() => updateAccessEnabled()}
                        className="form-check-toggle"
                      />
                      <Label check htmlFor="enableAccess" className="ms-4">
                        {accessEnabled ? "Enabled" : "Disabled"}
                      </Label>
                    </FormGroup>
                  )}
                </Form>
              </div>
            </Col>
          </>
        )}

        {canAccess() && <UpdatePhone open={phoneOpen} setOpen={setPhoneOpen} />}
        <UpdateEmail open={emailOpen} setOpen={setEmailOpen} />
      </Row>
    </>
  )
}

export default UpdateProfile
